import React from "react";
import { Content } from "@/models/document";
import { ContentsDisplayMode } from "@/models/widget-v2";
import EmbedComponent from "@/features/embed";

interface GridViewProps {
  items: Content[];
  displayMode?: ContentsDisplayMode;
}

const GridView: React.FC<GridViewProps> = ({ items, displayMode = "normal" }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {items.map((item, index) => (
        <div
          key={item.id || index}
          className="group"
        >
          <EmbedComponent
            content={item}
            displayMode={displayMode}
            mode="search"
          />
        </div>
      ))}
    </div>
  );
};

export default GridView;
